import { getResponseMessage } from '@app/shared/utils/response-message.util';
import { Component, OnInit, inject, Input, Output, EventEmitter } from '@angular/core';
import { CampanhaService } from '../api/services/campanha.service';
import { MessageService } from 'primeng/api';
import { EnumService } from '../api/services/enum.service';
import { forkJoin } from 'rxjs';
import { Select } from 'primeng/select';
import { Textarea } from 'primeng/textarea';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Dialog } from 'primeng/dialog';
import { Button } from 'primeng/button';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-rejeitar-campanha',
  standalone: true,
  imports: [
    Select,
    Textarea,
    CommonModule,
    ReactiveFormsModule,
    Dialog,
    Button
  ],
  providers: [
    CampanhaService,
    EnumService
  ],
  templateUrl: './rejeitar-campanha.component.html',
  styleUrl: './rejeitar-campanha.component.scss'
})
export class RejeitarCampanhaComponent implements OnInit {
  private readonly messageService = inject(MessageService);
  private readonly campanhaService = inject(CampanhaService);
  private readonly enumService = inject(EnumService);
  private readonly confirmationService = inject(ConfirmationService);
  private readonly fb = inject(FormBuilder);
  @Input() campanhaID!: number;
  @Input() visible: boolean = false;
  @Output() onClose = new EventEmitter<void>();
  form!: FormGroup;
  loading: boolean = false;
  motivos: any[] = [];
  Motivo: any;

  ngOnInit(): void {
    this.initiForm();
    this.loadDropdowns();
  }

  initiForm() {
    this.form = this.fb.group({
      motivo: [null, Validators.required],
      descricao: [null],
    });

    this.form.get('motivo')?.valueChanges.subscribe(value => {
      const descricao = this.form.get('descricao');

      if (value === 17) {
        descricao?.setValidators([Validators.required]);
      } else {
        descricao?.clearValidators();
        descricao?.reset();
      }

      descricao?.updateValueAndValidity();
    });
  }

  loadDropdowns() {
    forkJoin({
      motivoSupensao: this.enumService.getAllMotivoSuspensao(),
    }).subscribe((response) => {
      // Enums
      if (response.motivoSupensao?.data) {
        this.motivos = Object.entries(response.motivoSupensao.data).map(
          ([key, value]) => ({
            id: Number(key),
            label: value,
          })
        );
      }
    });
  }

  rejeitarCampanha() {
    if(this.form.invalid) {
      this.form.markAllAsTouched();
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Por favor, seleccione o motivo.',
        life: 5000,
      });
      return;
    }
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja rejeitar a publicação desta campanha?',
      header: 'Confirmação',
      closable: true,
      closeOnEscape: true,
      icon: 'pi pi-exclamation-triangle',
      rejectButtonProps: {
        label: 'Cancelar',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Sim, rejeitar',
      },
      accept: () => {
        this.loading = true;
        const id = String(this.campanhaID);
        if (this.form.get('motivo')?.value === 17) {
          this.Motivo = this.form.get('descricao')?.value;
        } else {
          this.Motivo = this.form.get('motivo')?.value;
        }
        const motivo = this.Motivo.toString();

        this.campanhaService.rejeit(id, motivo).subscribe({
          next: (res) => {
            if (res.retorno.codigo === 200) {
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: getResponseMessage(res, 'Campanha rejeitada com sucesso!'),
                life: 5000,
              });
              this.cancel();
              setTimeout(() => {
                this.onClose.emit();
                window.location.reload();
              }, 2000);
              this.loading = false;
            }
          },
          error: (err) => {
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: getResponseMessage(err, 'Ocorreu um erro ao rejeitar a campanha'),
              life: 5000,
            });
            this.loading = false;
            console.error(err);
          }
        });
      },
      reject: () => {
        // Ação ao cancelar (se necessário
      },
    });
  }

  isInvalid(field: string): boolean {
    const control = this.form.get(field);
    return !!(control && control.invalid && (control.dirty || control.touched));
  }

  handleClose() {
    this.form.reset();
    this.loading = false;
    this.onClose.emit();
  }

  cancel() {
    this.visible = false;
    this.handleClose();
  }
}